// Formattatore dei punteggi: separatore delle migliaia e decimali all'italiana (2741.5 -> 2.741,5)
const pointsFormatter = new Intl.NumberFormat('it-IT', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
});

// Formatta un punteggio, ritornando un placeholder se il valore non è numerico
export const formatPoints = (value, fallback = '—') => {
    const parsed = typeof value === 'number' ? value : parseFloat(value);
    return Number.isFinite(parsed) ? pointsFormatter.format(parsed) : fallback;
};

// Formatta un distacco, sempre con il segno esplicito (-3,5 / +3,5)
export const formatGap = (value) => {
    const parsed = typeof value === 'number' ? value : parseFloat(value);

    if (!Number.isFinite(parsed) || parsed === 0) {
        return null;
    }

    return `${parsed > 0 ? '+' : '-'}${pointsFormatter.format(Math.abs(parsed))}`;
};

export default { formatPoints, formatGap };
